import { ClientOnly } from "@winamp/ui/components/ClientOnly/ClientOnly.js";
import { type ComponentProps, Suspense, lazy, memo } from "react";

const LazyProductFruits = lazy(async () => {
  const { ProductFruits: ProductFruitsBase } = await import(
    "react-product-fruits"
  );

  return {
    default: function ProductFruits(
      props: ComponentProps<typeof ProductFruitsBase>,
    ) {
      return <ProductFruitsBase {...props} />;
    },
  };
});

const MemoProductFruits = memo(LazyProductFruits);

export function ProductFruits(props: ComponentProps<typeof MemoProductFruits>) {
  return (
    <ClientOnly>
      <Suspense>
        <MemoProductFruits {...props} />
      </Suspense>
    </ClientOnly>
  );
}
